export default __webpack_public_path__ + "static/media/sl3-min.245e85d0.jpg";